module.exports = __webpack_public_path__ + "img/ag-logo-lg.04617b09.svg";